import React, {useEffect, useRef, useState } from "react";
import { useNavigate } from "react-router-dom";
import { UserAuth } from "../../context/AuthContext";
import logo from "../../logo-no-background.png"
export default function ForgotPassword() {
    let navigate = useNavigate();
    const [email, setEmail] = useState("");
  let [error, setError] = useState("");
  const { resetPassword } = UserAuth();
  let handleForgotPass = async () => {
    setError("");
    try {
        await resetPassword(email);
        alert("Forgot Password email sent to your email address, please check inbox")
        setError("Check you inbox for further instructions")
    } catch(error) {
        setError(error.message);
        console.log(error.message);
    }
  };

  return (
    <div className="wrapper position-relative">
        <div className="header">
          <a className="logo" href={void(0)}>
            {/* <img src={logo} alt="" /> */}
            Adaptive Chinese Placement Test
          </a>
          <div className="right-content">
            <a href="#" onClick={() => navigate("/about")}>About</a>
          </div>
        </div>
          <div className="container">
            {error && <h3>{error}</h3>}
              <div className="multisteps_form position-relative overflow-hidden" id="wizard">
                <div className="row">
                    <div className="col-md-12">
                      <div className="form_header_content text-center pt-4">
                          <h2>Forgot Password</h2>
                          <div className="auth-form">
                          <input className="my-input" type="email" placeholder="Enter your email"
                            onChange={(event) => setEmail(event.target.value)} />
                          <button style={{alignSelf:"center", padding:"5px 25px"}} className="theme-btn" onClick={() => handleForgotPass()}> Forgot Password </button>
                          <a style={{textDecoration:"underline", color: "blue"}} onClick={() => navigate("/")}>Click here to Log In</a>
                        </div>
                      </div>
                      </div>
                    </div>
                </div>
          </div>
      </div>
  )
}
